import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';

export function* stopTranscriptionSaga() {
  yield call(SignalingSocket.send, {
    event: 'stopTranscription',
  });
}
